import { defineMessages } from '@jutro/locale';

export default defineMessages({
    Coverages: {
        id: 'ml.claim.views.ml-claim-details-coverages.Coverages',
        defaultMessage: 'Coverages'
    },
    PolicyNumber: {
        id: 'ml.claim.views.ml-claim-details-coverages.Policy#',
        defaultMessage: 'Policy#'
    }
});
